import React, { useEffect } from 'react';
import { Webform } from '@uncinc/react-drupal-core';
import { Fade } from 'react-awesome-reveal';

import { Container, FormikWrapper } from '@uncinc/uncinc-react-kitchen-sink';

import {
  Button,
  WysiwygField,
  PictureBackground,
  PatternBlock,
  DynamicMediaItem,
} from '../../../../components';

import './style.scss';

const CTAContent = ({ entity }) => {
  const backgroundImage = entity.getIn(['field_media', 0]);

  useEffect(() => {
    const element = document.querySelector('.CTAWithImage');
    if (element) element.classList.add('CTAWithImage--first');
  });

  return (
    <Fade triggerOnce bottom distance="50px" duration={500} clasName="Paragraph">
      <Container>
        <div className="CTAWithImage">
          <PatternBlock className="CTAWithImage__content">
            <div className="CTAWithImage__content__wrapper mb-6">
              <h2>{entity.getIn(['field_title', 0, 'value'])}</h2>
              <WysiwygField
                property="schema:text"
                html={entity.getIn(['field_body', 0, 'processed'])}
              />
              {entity.getIn(['field_webform', 0, 'target_id']) && entity.getIn(['field_webform', 0, 'target_id']) !== 'webform_' && (
                <FormikWrapper>
                  <Webform id={entity.getIn(['field_webform', 0, 'target_id'])} />
                </FormikWrapper>
              )}
            </div>
            {entity.getIn(['field_link', 0, 'uri']) && (
              <Button
                href={entity.getIn(['field_link', 0, 'uri'])}
                withIcon
                buttonIcon
                secondary
              >
                {entity.getIn(['field_link', 0, 'title'])}
              </Button>
            )}
          </PatternBlock>
          {backgroundImage && (
            <DynamicMediaItem
              className="CTAWithImage__image"
              media={backgroundImage.toJS()}
              imageAspectRatio="4_3"
            />
          )}
        </div>
      </Container>

    </Fade>
  );
};

export default CTAContent;
